import React from 'react'
import './FiltersActive.scss'
import { DeleteIcon } from '../utils/icons'
import { FilterActive } from './FilterActive'
import { connect } from 'react-redux'
import { setAllProducts, setSelectedForma, popFilter, setSelectedCategoryName, setSelectedCollection, setSelectedColor, setSelectedMinMaxDiameter, setSelectedHole, setSelectedNew, setSelectedCharacteristic, pushFilters, setPaginationState, setSelectedCategory, showSpinner, setProductsTable, resetFilters } from '../actions'
import { selectCategoryExpositor, selectCategoryImplantations, selectCategoryOutlet, selectCategoryPromoA, selectCategoryPromoB, selectCategoryPromoC } from '../hooks/selectCategory'
import { BRANDCHOSEN } from '../hooks/config'
import _ from 'lodash';

const FiltersActive = (props) => {
    const { productsToShow, filters, onClick } = props

    const handleRemoveAllFilters = () => {
        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            if (filter.filterType === 'category') { handleClickRemoveFilterCategory(filter) }
            if (filter.filterType === 'collection') { handleClickRemoveFilterCollection(filter) }
            if (filter.filterType === 'formas') { handleClickRemoveFilterFormas(filter) }
            if (filter.filterType === 'colores') { handleClickRemoveFilterColors(filter) }
            if (filter.filterType === 'diametro') { handleClickRemoveFilterDiameter(filter) }
            if (filter.filterType === 'hole') { handleClickRemoveFilterHole(filter) }
            if (filter.filterType === 'characteristic') { handleClickRemoveAllFilterCharacteristics(filter) }
        }
    }

    const handleClickRemoveFilterCategory = (filter) => {
        props.setSelectedCategoryName('')
        if (props.productsTable === 'allProducts') {
            props.setSelectedCategory({
                categoryId: '',
                subtitle: '',
                img: '',
                selectedCollection: ''
            })
        } else if (props.productsTable === 'allProductsOutlet') {
            selectCategoryOutlet(props)
        } else if (props.productsTable === 'allProductsExpositors') {
            selectCategoryExpositor(props)
        } else if (props.productsTable === 'allProductsPromoA') {
            selectCategoryPromoA(props)
        } else if (props.productsTable === 'allProductsPromoB') {
            selectCategoryPromoB(props)
        } else if (props.productsTable === 'allProductsPromoC') {
            selectCategoryPromoC(props)
        } else if (props.productsTable === 'allProductsImplantations') {
            selectCategoryImplantations(props)
        }
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterCollection = (filter) => {
        props.setSelectedCollection('')
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterFormas = (filter) => {
        props.setSelectedForma('')
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterColors = (filter) => {
        props.setSelectedColor('')
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterDiameter = (filter) => {
        props.setSelectedMinMaxDiameter(null)
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterHole = (filter) => {
        props.setSelectedHole(null)
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterNew = (filter) => {
        props.setSelectedNew(null)
        handleClickPopFilter(filter)
    }

    const handleClickRemoveAllFilterCharacteristics = (filter) => {
        props.setSelectedCharacteristic([])
        handleClickPopFilter(filter)
    }

    const handleClickRemoveFilterCharacteristics = (filter, characteristic) => {
        const indice = _.findIndex(filter.characteristicName, el => {
            return el === characteristic
        })
        if (indice !== -1) {
            filter.characteristicName.splice(indice, 1);
        }
        props.setSelectedCharacteristic(filter.characteristicName)
        props.pushFilters(filter)
        props.setPaginationState(1)
    }

    const handleClickPopFilter = (filter) => {
        props.popFilter(filter)
        props.setPaginationState(1)
    }

    return (
        <div className="filters-active-container">
            <div className="title">
                <div className="text">
                    <p>Filtros</p>
                </div>
                <div className="boton pointer" onClick={handleRemoveAllFilters}>
                    <div className={`icon-color-${BRANDCHOSEN}`}>
                      <DeleteIcon size={20} />
                    </div>
                    <p>Limpiar filtros</p>
                </div>
            </div>
            <div className="filters">
                {filters.map((filter, index) => (
                    <React.Fragment key={index}>
                        {
                            filter.filterType === 'category' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterCategory(filter)} >
                                <FilterActive filterName={filter.categoryName} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'collection' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterCollection(filter)} >
                                <FilterActive filterName={filter.collectionName} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'formas' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterFormas(filter)} >
                                <FilterActive filterName={filter.formasName} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'colores' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterColors(filter)} >
                                <FilterActive filterName={filter.color.nombre} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'diametro' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterDiameter(filter)} >
                                <FilterActive filterName={filter.filterType + " " + filter.minMaxDiameter[0] + " - " + filter.minMaxDiameter[1] + " cm"} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'hole' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterHole(filter)} >
                                <FilterActive filterName={filter.containHole} />
                            </div>
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'characteristic' && filter.characteristicName.map((characteristic, indexChar) => {
                                return (
                                    <div className="filter pointer" key={indexChar} onClick={() => handleClickRemoveFilterCharacteristics(filter, characteristic)} >
                                        <FilterActive filterName={characteristic} />
                                    </div>
                                )
                            })
                        }
                        {
                            filter.filterType !== 'category' && filter.filterType === 'new' &&
                            <div className="filter pointer" onClick={() => handleClickRemoveFilterNew(filter)} >
                                <FilterActive filterName={'Novedades'} />
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setSelectedForma,
    setSelectedCategoryName,
    setSelectedCollection,
    setSelectedColor,
    setSelectedMinMaxDiameter,
    setSelectedHole,
    setSelectedNew,
    setSelectedCharacteristic,
    setAllProducts,
    popFilter,
    pushFilters,
    setPaginationState,
    setSelectedCategory,
    showSpinner,
    setProductsTable,
    resetFilters
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(FiltersActive)





